export default "__VITE_ASSET__CCnLC2_O__"